

export default {
    name: 'MeatPageMainPoints',
    props: {
        points: {
            type: Array,
            required: true,
            default: () => ([])
        },
    }
}
